import { render, staticRenderFns } from "./ServiceAsking.vue?vue&type=template&id=70243dcc&scoped=true&"
import script from "./ServiceAsking.vue?vue&type=script&lang=js&"
export * from "./ServiceAsking.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAsking.vue?vue&type=style&index=0&id=70243dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70243dcc",
  null
  
)

export default component.exports